
import { defineComponent, ref, onMounted, PropType } from "vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "ChangeLogTable",
  props: {
    logType: {
      type: String as PropType<'balance' | 'point' | 'membership_point'>,
      required: true
    },
    userId: {
      type: Number,
      default: null
    },
    showUserColumn: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const filters = ref({
      user_mobile: '',
      log_type: '',
      min_amount: '',
      max_amount: ''
    });

    const dateRange = ref<string[] | null>(null);

    const page = ref({
      currentPage: 1,
      pageSize: 20,
      totalResult: 0
    });

    const items = ref<any[]>([]);
    const logTypes = ref<any[]>([]);

    const loadData = () => {
      ApiService.setHeader();

      const params: any = {
        currentPage: page.value.currentPage,
        pageSize: page.value.pageSize
      };

      if (props.userId) {
        params.user_id = props.userId;
      }
      if (filters.value.user_mobile) {
        params.user_mobile = filters.value.user_mobile;
      }
      if (dateRange.value && dateRange.value.length === 2) {
        params.date_from = dateRange.value[0];
        params.date_to = dateRange.value[1];
      }
      if (filters.value.log_type) {
        params.log_type = filters.value.log_type;
      }
      if (filters.value.min_amount !== '') {
        params.min_amount = filters.value.min_amount;
      }
      if (filters.value.max_amount !== '') {
        params.max_amount = filters.value.max_amount;
      }

      let queryString = "?";
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          queryString += `${key}=${params[key]}&`;
        }
      });

      ApiService.get(`admin/change_logs/${props.logType}`, queryString)
        .then(({ data }) => {
          items.value = data.data.items;
          page.value.totalResult = data.data.total;
          if (data.data.log_types) {
            logTypes.value = data.data.log_types;
          }
        })
        .catch(() => {
          items.value = [];
          page.value.totalResult = 0;
        });
    };

    const handleSearch = () => {
      page.value.currentPage = 1;
      loadData();
    };

    const onPageChange = (evt: any) => {
      const { type, currentPage, pageSize } = evt;
      if (type === 'size') {
        page.value.currentPage = 1;
      } else {
        page.value.currentPage = currentPage;
      }
      page.value.pageSize = pageSize;
      loadData();
    };

    onMounted(() => {
      loadData();
    });

    return {
      filters,
      dateRange,
      page,
      items,
      logTypes,
      loadData,
      handleSearch,
      onPageChange
    };
  }
});
